export default __webpack_public_path__ + "static/media/cancelcritical.a14bf661.png";